import { render } from "./packing_list.vue?vue&type=template&id=43af2be2&scoped=true"
import script from "./packing_list.vue?vue&type=script&lang=js"
export * from "./packing_list.vue?vue&type=script&lang=js"

import "./packing_list.vue?vue&type=style&index=0&id=43af2be2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43af2be2"]])

export default __exports__